import { motion } from "framer-motion";
import { useSettings } from "@/context/SettingsContext";
import { Reveal } from "@/components/Reveal";

export const Process = () => {
  const settings = useSettings();
  const steps = settings.process || [];
  return (
    <section
      id="werkwijze"
      data-testid="process-section"
      className="py-24 md:py-32 bg-[#0a0a0a] border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="max-w-2xl mb-16">
          <span className="text-[#FF1A1A] text-sm font-semibold tracking-[0.25em] uppercase">
            Werkwijze
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-white mt-5 leading-tight">
            Van kennismaking <br /> tot oplevering.
          </h2>
        </Reveal>

        <div className="relative flex flex-col md:flex-row items-start justify-between gap-10 md:gap-6">
          <div className="hidden md:block absolute top-6 left-0 w-full h-[1px] bg-white/10 -z-0" />
          {steps.map((step, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: i * 0.12, ease: "easeOut" }}
              data-testid={`process-step-${i}`}
              className="flex flex-col gap-4 relative w-full md:w-1/5 bg-[#0a0a0a]"
            >
              <div className="w-12 h-12 rounded-full bg-[#111111] border-2 border-[#FF1A1A] flex items-center justify-center text-[#FF1A1A] font-bold font-heading text-lg z-10">
                {String(i + 1).padStart(2, "0")}
              </div>
              <h3 className="font-heading text-xl font-semibold text-white">
                {step.title}
              </h3>
              <p className="text-sm text-white/55 font-light leading-relaxed">
                {step.text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
